import ReactDOM from "react-dom";
import App from "./components/App";
import './styles.css';

ReactDOM.render(<App />, document.querySelector("#root"));
